import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const FormFooter = ({ text, linkText, link, buttonText }) => {
  return (
    <>
      <Typography my={3} color="text.primary">
        {text}
        <Link
          to={`/${link}`}
          style={{
            color: "yellow",
            margin: "0 3px",
            textDecoration: "none",
          }}
        >
          {linkText}
        </Link>
        here
      </Typography>
      <Box display="flex" justifyContent="end" mt="20px">
        <Button type="submit" color="secondary" variant="contained">
          {buttonText}
        </Button>
      </Box>
    </>
  );
};

export default FormFooter;
